import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  padding: 16px;
  padding-bottom: 80px;

  h3 {
    margin-bottom: 16px;
    margin-top: 0px;
    padding: 0 24px;

    @media (max-width: 768px) {
      padding: 0;
      max-width: calc(100vw - 32px);
    }
  }

  .info-banner {
    display: flex;
    gap: 12px;
    padding: 14px 16px;
    margin: 24px 0 0 0;
    background: linear-gradient(135deg, #e3f2fd 0%, #f0f7ff 100%);
    border: 1px solid #2196f3;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(33, 150, 243, 0.1);

    @media (max-width: 768px) {
      margin: 16px 0 0 0;
    }
  }

  .info-icon {
    font-size: 20px;
    line-height: 1.4;
    flex-shrink: 0;
  }

  .info-content {
    flex: 1;
  }

  .info-text {
    font-size: 14px;
    color: #0d47a1;
    line-height: 1.5;
  }

  .info-link {
    color: #1976d2;
    font-weight: 600;
    cursor: pointer;
    text-decoration: underline;
    transition: color 0.2s;

    &:hover {
      color: #0d47a1;
    }
  }

  .preview-wrapper {
    margin: 8px -32px 24px -32px;
  }

  button {
    margin: 0 16px;
    margin-bottom: 24px;
    padding: 0 16px;
    width: 160px;

    &[data-variant='as-text'] {
      width: auto;
    }
  }

  button.save-button {
    margin-top: 24px;

    @media (max-height: 1100px) {
      position: fixed;
      bottom: 16px;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 98;
      width: 150px;
      justify-content: center;
      box-shadow: 0 0px 4px #454f5b44;
    }
  }

  .form-section {
    margin-bottom: 24px;
    padding: 24px;

    background: ${props => props.theme.white};
    border-radius: 8px;

    @media (max-width: 768px) {
      padding: 16px;
    }
  }

  .section-question {
    font-weight: 600;
    font-size: 17px;
    margin: 0 0 8px 0;
    color: ${props => props.theme.text};
  }

  .setting-explainer {
    font-size: 14px;
    color: ${props => props.theme.secondaryText};
    margin-bottom: 16px;
  }

  .section-question {
    &:not(:first-child) {
      margin-top: 32px;
      padding-top: 32px;
      border-top: 1px solid ${props => props.theme.border};
    }
  }

  .button-cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
  }

  .button-card {
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    background: ${props => props.theme.white};
    border: 1px solid ${props => props.theme.border}88;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.25, 1, 0.32, 1);
    width: auto;
    flex-shrink: 0;
    box-shadow: 0 0px 12px ${props => props.theme.mutedText}33;
    justify-content: center;

    @media (max-width: 768px) {
      width: 100%;
    }

    &:hover:not(.enabled) {
      box-shadow: 0 0px 12px ${props => props.theme.mutedText}55;
    }

    &.enabled {
      filter: none;
    }

    &.expanded {
      width: calc(50% - 4px);

      @media (max-width: 768px) {
        width: 100%;
      }
    }
  }

  .button-card-header {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .button-card-icon {
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    img {
      width: 28px;
      height: 28px;
      object-fit: contain;
      border-radius: 8px;
    }
  }

  .button-card-name {
    font-weight: 500;
    font-size: 15px;
    color: ${props => props.theme.text};
    flex: 1;
    white-space: nowrap;
  }

  .button-card-toggle {
    .react-toggle-wrapper {
      margin-top: 0;
      margin-left: 8px;
    }
  }

  .button-card-content {
  }

  .button-card-input {
    width: 100%;
    padding: 12px;
    border: 1px solid ${props => props.theme.border};
    border-radius: 8px;
    font-size: 15px;
    font-family: 'Montserrat', sans-serif;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: ${props => props.theme.blue};
    }
  }

  .form-label {
    display: block;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 12px;
    color: ${props => props.theme.text};
  }

  .discount-input-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .discount-label {
    font-size: 15px;
    color: ${props => props.theme.text};
  }

  .ios-toggle {
    margin-top: 0px;
    width: 100%;
    max-width: 100%;
  }

  .url-preview {
    margin-top: 16px;
    font-size: 14px;
    line-height: 1.6;

    .url {
      padding: 8px 12px;
      border-radius: 8px;
      background-color: ${props => props.theme.accent}15;
      font-weight: 500;
      position: relative;
      flex-direction: row;
      display: inline-flex;
      gap: 4px 8px;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 8px;
      word-break: break-all;
    }

    .copy-url-button {
      padding: 5px 12px;
      font-size: 12px;
      font-weight: 600;
      font-family: 'Montserrat', sans-serif;
      color: ${props => props.theme.accent};
      background: ${props => props.theme.white};
      border: 1.5px solid ${props => props.theme.accent}66;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.15s ease;
      white-space: nowrap;
      vertical-align: middle;
      box-shadow: 0 1px 3px ${props => props.theme.accent}15;
      margin: 0;
      width: auto;

      &:hover {
        background: ${props => props.theme.accent};
        color: white;
        border-color: ${props => props.theme.accent};
        box-shadow: 0 2px 6px ${props => props.theme.accent}25;
      }

      &:active {
        transform: translateY(1px);
        box-shadow: 0 1px 2px ${props => props.theme.accent}20;
      }
    }
  }
`
